const formatNumber = (montant: number | null): string => {
  if (montant === null || Number.isNaN(montant)) return ''
  return new Intl.NumberFormat('fr-FR').format(montant)
}

export default formatNumber
